module.exports = __webpack_public_path__ + "static/media/contact-bg (2).svg:Zone.7a821669.Identifier";